import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'

//vant
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
import { Lazyload } from 'vant'
Vue.use(Lazyload)
//global less
import '@/assets/less/global.less'

//jQuery
import $ from 'jquery'

//工具函数
import utils from '@/assets/lib/utils'
Vue.prototype.$utils = utils

//移动端active 解决
document.body.addEventListener('touchstart', function() {})

// //移动端点击延迟解决
// import FastClick from 'fastclick'
// FastClick.attach(document.body)

//单页每页 title解决
router.beforeEach((to, from, next) => {
  window.document.title = to.name
  next()
})

//过滤器
import filters from '@/assets/lib/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
import Load from '@/components/Loading'
Vue.component('Load', Load)
//全局变量
import config from '@/assets/lib/conf'
Vue.use(config)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
